import * as React from 'react'

import { Tag } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type SurveyForm from 'modules/surveys/store/models/Form'

interface Props {
  form: SurveyForm
}

export default function FormState({ form }: Props) {
  const StateColor = {
    draft: Tag.Types.champagne,
    active: Tag.Types.lime,
    finished: Tag.Types.radical,
  }

  const getType = (form: SurveyForm) => {
    if (form.isDraft) {
      return StateColor.draft
    }

    if (form.isActive) return StateColor.active

    return StateColor.finished
  }

  const labelType = getType(form)
  const questionaireState = form.attributes.state

  const tagLabel = (questionaireState: string) => {
    switch (questionaireState) {
      case 'draft':
        return i18n.t('surveys.index.table.filters.draft')
      case 'active':
        return i18n.t('surveys.index.table.filters.active')
      case 'finished':
        return i18n.t('surveys.index.table.filters.closed')
      default:
        return i18n.t('surveys.index.table.filters.unknown')
    }
  }

  const genericLabel = tagLabel(questionaireState)

  return (
    <Tag leftItem="circle" capitalize showCircle type={labelType}>
      {genericLabel}
    </Tag>
  )
}
